import { render, staticRenderFns } from "./ViewLeaveRequest.vue?vue&type=template&id=25966b76"
import script from "./ViewLeaveRequest.vue?vue&type=script&lang=js"
export * from "./ViewLeaveRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports